// @flow

import React from 'react';
import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import { sortModeViewModel } from '@seek/seek-refine-job-search';

import type { Option } from './LinkSelect/LinkSelect';
import LinkSelect from './LinkSelect/LinkSelect';
import { sortModeChanged } from 'src/store/search/search';

type Props = {
  sortModeOptions?: Array<Option>,
  onSortModeChange: Function
};

const sortModeViewModelSelector = () =>
  createSelector(
    state => state.search.query,
    state => state.results.sortMode,

    (searchQuery, sortMode) => ({
      sortModeOptions: sortModeViewModel({ searchQuery, sortMode })
    })
  );

function mapDispatchToProps(dispatch) {
  return {
    onSortModeChange: () => dispatch(sortModeChanged())
  };
}

const Filters = ({ sortModeOptions, onSortModeChange }: Props) =>
  sortModeOptions && (
    <LinkSelect
      id="sortModeFilter"
      label="Sorted by"
      options={sortModeOptions}
      onChange={onSortModeChange}
    />
  );

Filters.defaultProps = {
  sortModeOptions: null
};

export default connect(
  sortModeViewModelSelector,
  mapDispatchToProps
)(Filters);
